var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(this.$route.path !== '/' &&
      this.$route.path.toLowerCase() !== '/recuperar-registro' &&
      this.$route.path.toLowerCase() !== '/selecionar-paciente' &&
      this.$route.path.toLowerCase() !== '/redefinicao-de-senha' &&
      this.$route.path.toLowerCase() !== '/recuperacao-de-senha' ? true : false)?_c('intro-header'):_vm._e(),_vm._t("default"),_c('div',{staticClass:"floating-buttons"},[_c('print-button'),_c('helper-button')],1),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }